import request from '@/utils/request'

// 等级配置
export function getLevelConfigPage(params) {
  return request({ url: '/admin/level/page', method: 'get', params })
}

export function getLevelConfigList() {
  return request({ url: '/admin/level/list', method: 'get' })
}

export function getLevelOptions() {
  return request({ url: '/admin/level/options', method: 'get' })
}

export function getLevelConfigDetail(id) {
  return request({ url: `/admin/level/${id}`, method: 'get' })
}

export function createLevelConfig(data) {
  return request({ url: '/admin/level', method: 'post', data })
}

export function updateLevelConfig(data) {
  return request({ url: '/admin/level', method: 'put', data })
}

export function deleteLevelConfig(ids) {
  return request({ url: '/admin/level', method: 'delete', data: ids })
}

export function getLevelStatistics() {
  return request({ url: '/admin/level/statistics', method: 'get' })
}

// 经验值日志
export function getExperienceLogPage(params) {
  return request({ url: '/admin/experience/log/page', method: 'get', params })
}
